import BlogCategoriesView from "@/systems/modules/blog/BlogCategoriesView.vue";
import {modules} from "@/systems/modules/modules.js";
import {RouterView} from "vue-router";
import BlogHeaderView from "@/systems/modules/blog/BlogHeaderView.vue";
import authorization from "@/authorization";
import BlogCategoryHeaderView from "@/systems/modules/blog/BlogCategoryHeaderView.vue";
import BlogPostsView from "@/systems/modules/blog/BlogPostsView.vue";

export default {
    initialize() {

    },
    getRoutes: () => ([
        {
            name: "community.modules.blog",
            path: "blog",
            component: RouterView,
            props: true,
            meta: {
                authorize: () => authorization.moduleEnabled(modules.blog) && (authorization.permission("modules.blog.categories.edit") || authorization.permission("modules.blog.posts.edit") || authorization.resourceTypePermission("modules.blog.category", "posts.edit")),
            },
            redirect: { name: "community.modules.blog.categories" },
            children: [
                {
                    path: "categories",
                    component: RouterView,
                    props: true,
                    children: [
                        {
                            name: "community.modules.blog.categories",
                            path: "",
                            component: BlogCategoriesView,
                            props: true
                        },
                        {
                            name: "community.modules.blog.category",
                            path: ":categoryId",
                            component: BlogCategoryHeaderView,
                            props: true,
                            redirect: { name: "community.modules.blog.category.posts" },
                            children: [
                                {
                                    name: "community.modules.blog.category.posts",
                                    path: "posts",
                                    component: BlogPostsView,
                                    props: true
                                },
                            ]
                        },
                    ]
                }
            ]
        }
    ])
};